import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'

class DerivedImportanceSlide {
    id = uuidv4()

    kind = 'DerivedImportanceSlide'

    pageQuestionId

    kpiPageQuestionId

    removeBaseLimit

    constructor({ kpiPageQuestionId, pageQuestionId }) {
        this.kpiPageQuestionId = kpiPageQuestionId
        this.pageQuestionId = pageQuestionId
    }

    toJSON() {
        return {
            kind: this.kind,
            pageQuestionId: this.pageQuestionId,
            kpiPageQuestionId: this.kpiPageQuestionId,
            removeBaseLimit: !R.isNil(this.removeBaseLimit)
                ? parseInt(this.removeBaseLimit, 10)
                : undefined,
        }
    }
}

export default DerivedImportanceSlide
